import React from 'react';
import { Form } from 'antd';
import cn from 'classnames';
import styles from './FormItem.module.scss';

const FormItem = ({ className, hasAction = false, ...props }) => {
  return (
    <Form.Item
      {...props}
      className={cn(styles.root, className, {
        [styles.hasAction]: hasAction,
      })}
    />
  );
};

export default FormItem;
